import RangeRentalPage from "./RangeRentalPage";
import registrationStep from "../../registrationStep";

export default registrationStep(RangeRentalPage, "range-rental", "minors");



// WEBPACK FOOTER //
// ./src/registration/components/RangeRental/index.js